<template>
    <select
        @input="$emit('input', $event.target.value)"
        v-bind="$attrs"
        v-model="code"
        :disabled="isDisabled"
        aria-invalid="false"
    >
        <option value="1">1</option>
        <option value="7">7</option>
        <option value="20">20</option>
        <option value="27">27</option>
        <option value="30">30</option>
        <option value="31">31</option>
        <option value="32">32</option>
        <option value="33">33</option>
        <option value="34">34</option>
        <option value="36">36</option>
        <option value="39">39</option>
        <option value="40">40</option>
        <option value="41">41</option>
        <option value="43">43</option>
        <option value="44">44</option>
        <option value="45">45</option>
        <option value="46">46</option>
        <option value="47">47</option>
        <option value="48">48</option>
        <option value="49">49</option>
        <option value="51">51</option>
        <option value="52">52</option>
        <option value="54">54</option>
        <option value="55">55</option>
        <option value="56">56</option>
        <option value="57">57</option>
        <option value="58">58</option>
        <option value="60">60</option>
        <option value="61">61</option>
        <option value="62">62</option>
        <option value="63">63</option>
        <option value="64">64</option>
        <option value="65">65</option>
        <option value="66">66</option>
        <option value="81">81</option>
        <option value="82">82</option>
        <option value="84">84</option>
        <option value="86">86</option>
        <option value="90">90</option>
        <option value="91">91</option>
        <option value="211">211</option>
        <option value="212">212</option>
        <option value="213">213</option>
        <option value="216">216</option>
        <option value="218">218</option>
        <option value="249">249</option>
        <option value="255">255</option>
        <option value="260">260</option>
        <option value="267">267</option>
        <option value="297">297</option>
        <option value="351">351</option>
        <option value="352">352</option>
        <option value="353">353</option>
        <option value="354">354</option>
        <option value="355">355</option>
        <option value="356">356</option>
        <option value="357">357</option>
        <option value="358">358</option>
        <option value="359">359</option>
        <option value="370">370</option>
        <option value="371">371</option>
        <option value="372">372</option>
        <option value="375">375</option>
        <option value="380">380</option>
        <option value="381">381</option>
        <option value="382">382</option>
        <option value="385">385</option>
        <option value="386">386</option>
        <option value="387">387</option>
        <option value="389">389</option>
        <option value="420">420</option>
        <option value="421">421</option>
        <option value="502">502</option>
        <option value="503">503</option>
        <option value="504">504</option>
        <option value="505">505</option>
        <option value="506">506</option>
        <option value="507">507</option>
        <option value="590">590</option>
        <option value="591">591</option>
        <option value="593">593</option>
        <option value="595">595</option>
        <option value="596">596</option>
        <option value="598">598</option>
        <option value="599">599</option>
        <option value="849">849</option>
        <option value="868">868</option>
        <option value="852">852</option>
        <option value="886">886</option>
        <option value="961">961</option>
        <option value="962">962</option>
        <option value="963">963</option>
        <option value="964">964</option>
        <option value="965">965</option>
        <option value="966">966</option>
        <option value="967">967</option>
        <option value="968">968</option>
        <option value="971">971</option>
        <option value="972">972</option>
        <option value="973">973</option>
        <option value="974">974</option>
        <option value="1787">1787</option>
        <option value="1809">1809</option>
        <option value="1876">1876</option>
    </select>
</template>
<script>
export default {
    props: {
        value: [String, Number],
        defaultValue: {
            type: Number,
            default: 44
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return { values: [], code: null };
    },
    watch: {
        value(val) {
            this.code = val ? val : this.defaultValue;
        }
    },
    mounted() {
        this.code = this.value ? this.value : this.defaultValue;
        this.$emit("input", this.code);
    },
    methods: {}
};
</script>
